import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Facebook, Instagram, Youtube, Mail, MapPin } from '../icons';
import { useLanguage } from '../context/LanguageContext';

// Social profiles are set at build time. An icon whose URL is not configured is
// left out rather than shown as a link that goes nowhere.
const SOCIAL_LINKS = [
  { label: 'Facebook', url: process.env.REACT_APP_FACEBOOK_URL, Icon: Facebook },
  { label: 'Instagram', url: process.env.REACT_APP_INSTAGRAM_URL, Icon: Instagram },
  { label: 'YouTube', url: process.env.REACT_APP_YOUTUBE_URL, Icon: Youtube },
].filter((s) => s.url);

function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-col">
            <div className="footer-logo">
              <Heart className="logo-icon" />
              <span>NepWed</span>
            </div>
            <p className="footer-desc">
              {t('footer.description')}
            </p>
            {SOCIAL_LINKS.length > 0 && (
              <div className="footer-social">
                {SOCIAL_LINKS.map(({ label, url, Icon }) => (
                  <a key={label} href={url} target="_blank" rel="noopener noreferrer" aria-label={label}><Icon size={20} /></a>
                ))}
              </div>
            )}
          </div>

          <div className="footer-col">
            <h4>{t('footer.planningTools')}</h4>
            <Link to="/checklist">{t('footer.weddingChecklist')}</Link>
            <Link to="/budget">{t('footer.budgetTracker')}</Link>
            <Link to="/guests">{t('footer.guestListManager')}</Link>
            <Link to="/wedding-website">{t('footer.weddingWebsite')}</Link>
          </div>

          <div className="footer-col">
            <h4>{t('footer.vendorCategories')}</h4>
            <Link to="/vendors/venues">Venues</Link>
            <Link to="/vendors/photographers">Photographers</Link>
            <Link to="/vendors/caterers">Caterers</Link>
            <Link to="/vendors/decorators">Decorators</Link>
            <Link to="/vendors/beauty-makeup">Bridal Makeup</Link>
            <Link to="/vendors/mehendi-artists">Mehendi Artists</Link>
            <Link to="/vendors/florists">Florists</Link>
            <Link to="/vendors/djs-music">DJs & Music</Link>
            <Link to="/vendors/pandits-priests">Pandits & Priests</Link>
            <Link to="/vendors/wedding-planners">Wedding Planners</Link>
            <Link to="/vendors/jewellers">Jewellers</Link>
            <Link to="/vendors/bridal-wear">Bridal Wear</Link>
            <Link to="/vendors/invitation-cards">Invitation Cards</Link>
          </div>

          <div className="footer-col">
            <h4>{t('footer.contactUs')}</h4>
            <div className="footer-contact">
              <p><MapPin size={16} /> Durbar Marg, Kathmandu, Nepal</p>
              <p><Mail size={16} /> contact@nepwed.com</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} NepWed.com — {t('footer.madeWith')} <Heart size={14} className="heart-icon" /> {t('footer.inNepal')}</p>
          <div className="footer-links">
            <Link to="/privacy-policy">{t('footer.privacyPolicy')}</Link>
            <Link to="/terms-of-service">{t('footer.termsOfService')}</Link>
            <Link to="/about">{t('footer.aboutUs')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
